module.exports = __webpack_public_path__ + "static/media/warning.b22fa3ea.png";